import React, { useRef, useState } from 'react';
import { Stage, Layer } from 'react-konva';
import { GridLayer } from './GridLayer';
import { RoomRenderer } from './RoomRenderer';
import { useMouseEvents } from '../hooks/useMouseEvents.hook';
import { useApp } from '../stateMgmt/AppContext';


const METERS_TO_PIXELS_SCALE = 100;

export function BuildingCanvas() {
  const { stageSize, position, scale, isDragging, setScale, handleWheel, handleMouseDown, handleMouseMove, handleMouseUp, handleTouchStart, handleTouchMove, handleTouchEnd } = useMouseEvents();
  const { currentFloorId, showGrid, showDimensions, setPendingRoomPosition, building } = useApp();
  const stageRef = useRef(null);
  const currentFloor = building?.floors.find(f => f.id === currentFloorId) ?? building?.floors[0];

  const handleRoomCreation = (e) => {
    const stage = e.target.getStage();
    if (!stage) return;

    const pointerPos = stage.getPointerPosition();
    if (!pointerPos) return;

    // Convert screen coordinates to world coordinates (meters)
    const stageScaleX = stage.scaleX();
    const stageScaleY = stage.scaleY();
    const stageX = stage.x();
    const stageY = stage.y();

    const worldPos = {
        x: (pointerPos.x - stageX) / stageScaleX,
        y: (pointerPos.y - stageY) / stageScaleY
    };

    // Store position and open dialog
    //setPendingRoomPosition(worldPos);
    //setRoomCreationDialogOpen(true);
    console.log('handleDoubleClick', worldPos);
    setPendingRoomPosition(worldPos);
};

  return (
    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
      <Stage
        ref={stageRef}
        width={stageSize.width}
        height={stageSize.height}
        x={position.x}
        y={position.y}
        scaleX={scale * METERS_TO_PIXELS_SCALE}
        scaleY={scale * METERS_TO_PIXELS_SCALE}
        onWheel={handleWheel}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        onDblClick={handleRoomCreation}
        style={{ cursor: isDragging.current ? 'grabbing' : 'grab' }}
      >
        {/* Grid layer */}
        {showGrid && (
          <GridLayer
            scale={scale * METERS_TO_PIXELS_SCALE}
            position={position}
            stageWidth={stageSize.width}
            stageHeight={stageSize.height}
          />
        )}

        {/* Rooms layer - no Group needed, scale is on Stage */}
        <Layer>
          {currentFloor?.rooms.map(room => {
            return (
              <React.Fragment key={room.id}>
                {/* Render room - no scale prop needed, handled by Layer */}
                <RoomRenderer
                  room={room}
                />
              </React.Fragment>
            );
          })}
        </Layer>
      </Stage>

      {/* Zoom controls */}
      <div style={{
        position: 'absolute',
        bottom: 20,
        right: 20,
        display: 'flex',
        flexDirection: 'column',
        gap: 10
      }}>
        <button
          onClick={() => {
            // Zoom in by 5%
            const currentPercentage = scale * 100;
            const newPercentage = Math.min(500, currentPercentage + 5);
            setScale(newPercentage / 100);
          }}
          style={{
            padding: '10px 15px',
            fontSize: '18px',
            cursor: 'pointer',
            border: '1px solid #ccc',
            borderRadius: '4px',
            backgroundColor: '#fff'
          }}
        >
          +
        </button>
        <button
          onClick={() => {
            // Zoom out by 5%
            const currentPercentage = scale * 100;
            const newPercentage = Math.max(10, currentPercentage - 5);
            setScale(newPercentage / 100);
          }}
          style={{
            padding: '10px 15px',
            fontSize: '18px',
            cursor: 'pointer',
            border: '1px solid #ccc',
            borderRadius: '4px',
            backgroundColor: '#fff'
          }}
        >
          −
        </button>
        <div style={{
          padding: '5px 10px',
          textAlign: 'center',
          fontSize: '12px',
          border: '1px solid #ccc',
          borderRadius: '4px',
          backgroundColor: '#fff'
        }}>
          {Math.round(scale * 100)}%
        </div>
      </div>

      {/* Room Creation Dialog */}
      {/* <RoomCreationDialog
        open={roomCreationDialogOpen}
        onClose={() => {
          setRoomCreationDialogOpen(false);
          setPendingRoomPosition(null);
        }}
        onCreate={handleCreateRoom}
        initialPosition={pendingRoomPosition}
      /> */}
    </div>
  );
}

/* {windows?.map(window => <WindowRenderer key={window.id} window={window} wall={window.wall} />)}
                {electricityPoints?.map(point => <ElectricityPointRenderer key={point.id} point={point} wall={point.wall} />)} */

